import { InvalidIcon, ValidIcon } from '../../../shared/icons/icons';
import './PasswordRequirement.css';

export enum RequirementStatus {
    INITIAL = 'initial',
    FULFILLED = 'fulfilled',
    NOT_FULFILLED = 'not-fulfilled',
}

interface IProps {
    name: string;
    status: RequirementStatus;
}

export const PasswordRequirement = (props: IProps) => {
    const { name, status } = props;

    const getIcon = () => {
        switch (status) {
            case RequirementStatus.INITIAL:
                return <></>;
            case RequirementStatus.FULFILLED:
                return <ValidIcon />;
            case RequirementStatus.NOT_FULFILLED:
                return <InvalidIcon />;
        }
    };

    return (
        <div
            data-testid={'password-requirement'}
            className='d-flex mt-2 align-items-center requirements-wrapper'
        >
            <div
                data-testid={'requirement-bullet'}
                className={`requirement-bullet bullet-${status}`}
            ></div>
            <p
                data-testid={'requirement-name'}
                className={`requirement-${status} mb-0 ml-3`}
            >
                {name}
            </p>
            <div className='ml-2'>{getIcon()}</div>
        </div>
    );
};
